import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { routerShape } from '@bibliocommons/bc-prop-types';
import { withRouter } from '@bibliocommons/utils-routing';
import ModalActions from 'app/actions/ModalActions';
import PreviewActions from 'app/actions/PreviewActions';
import { selectPreviewTransactions } from 'app/selectors/PreviewSelector';
import PreviewBar from './PreviewBar';

/*
 * This PreviewBarContainer can be rendered by any component, but it's
 * always displayed right below the header, thus irrespective of the
 * components hierarchy of the page. See the `MainLayout` component.
 */

export class PreviewBarContainer extends React.PureComponent {
  state = { node: null };

  componentDidMount() {
    if (!this.state.node) {
      this.setState({
        node: document.getElementById('preview-bar')
      });
    }
  }

  render() {
    const { node } = this.state;
    const { router, ...props } = this.props;

    return node ? ReactDOM.createPortal(<PreviewBar {...props} location={router.location} />, node) : null;
  }
}

PreviewBarContainer.defaultProps = {
  optedIn: true
};

PreviewBarContainer.propTypes = {
  featureName: PropTypes.string.isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func),
  optedIn: PropTypes.bool,
  previewActions: PropTypes.objectOf(PropTypes.func),
  previewTransactions: ImmutablePropTypes.map,
  router: routerShape.isRequired
};

const mapStateToProps = state => ({
  previewTransactions: selectPreviewTransactions(state)
});

const mapDispatchToProps = dispatch => ({
  modalActions: bindActionCreators(ModalActions, dispatch),
  previewActions: bindActionCreators(PreviewActions, dispatch)
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PreviewBarContainer));
